import type { PublishedPopup } from "./types";

// Frequência de exibição por visitante, via localStorage. Chaves por popup.
// Regras (do card): não exibir por N dias após fechar; limite de exibições por
// visitante (0 = ilimitado); não exibir novamente após conversão.

const KEY = (popupId: string) => `atd_popup_${popupId}`;

interface PopupState {
  shownCount?: number;
  lastClosedAt?: number; // epoch ms
  converted?: boolean;
}

const read = (popupId: string): PopupState => {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(KEY(popupId));
    return raw ? (JSON.parse(raw) as PopupState) : {};
  } catch {
    return {};
  }
};

const write = (popupId: string, state: PopupState) => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY(popupId), JSON.stringify(state));
  } catch {
    // storage indisponível (modo privado/cota) — silencioso, popup só não respeita frequência
  }
};

export const canShowPopup = (popup: PublishedPopup): boolean => {
  const { frequency } = popup;
  const state = read(popup.id);

  if (frequency?.hideAfterConversion && state.converted) return false;

  if (frequency?.viewLimit && frequency.viewLimit > 0) {
    if ((state.shownCount ?? 0) >= frequency.viewLimit) return false;
  }

  if (frequency?.daysAfterClose && frequency.daysAfterClose > 0 && state.lastClosedAt) {
    const elapsedDays = (Date.now() - state.lastClosedAt) / (1000 * 60 * 60 * 24);
    if (elapsedDays < frequency.daysAfterClose) return false;
  }

  return true;
};

export const markShown = (popupId: string) => {
  const state = read(popupId);
  write(popupId, { ...state, shownCount: (state.shownCount ?? 0) + 1 });
};

export const markClosed = (popupId: string) => {
  const state = read(popupId);
  write(popupId, { ...state, lastClosedAt: Date.now() });
};

export const markConverted = (popupId: string) => {
  const state = read(popupId);
  write(popupId, { ...state, converted: true });
};
